import { getWordsCount } from '../../Stats/Logic/Reports';
import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class PigeonBadge extends WritingBadge {
  public readonly id = BadgeId.pigeon;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    return (getWordsCount([stats.todaysPage]) || 0) > 500;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/pigeon.ts